import React from 'react'
import { Ordering } from 'storfox-filter'

import { SALE_ORDER_COLUMNS as tableColumns } from './SaleOrderTable'

import { FILTER_NAME as name } from '../../constants/SaleOrder'

export const saleOrderOrderingOptions = {
  name,
  tableColumns
}

function SaleOrderOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default SaleOrderOrderingForm
